import e from "../managers/braze-instance.js";
export function requestImmediateDataFlush(t) {
  if (!e.rr()) return;
  const r = e.cr();
  r && r.requestImmediateDataFlush(t);
}
